// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportConfigCard_createNewConfig__J817L {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 100%;
}

.ReportConfigCard_cardTitle__dITpC {
  flex: 1 1;
  overflow: hidden;
}

.ReportConfigCard_buttonContainer__L5cix {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.ReportConfigCard_buttonContainer__L5cix .ReportConfigCard_generateButton__seUD9 {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.ReportConfigCard_buttonContainer__L5cix .ReportConfigCard_tableListButtons__VATcQ {
  display: flex;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ReportConfigurator/ReportConfigCard.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AACJ;AAEE;EACE,aAAA;EACA,WAAA;AAAJ","sourcesContent":[".createNewConfig {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  height: 100%;\n}\n\n.cardTitle {\n  flex: 1;\n  overflow: hidden;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n}\n.buttonContainer .generateButton {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.buttonContainer .tableListButtons {\n  display: flex;\n  gap: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createNewConfig": `ReportConfigCard_createNewConfig__J817L`,
	"cardTitle": `ReportConfigCard_cardTitle__dITpC`,
	"buttonContainer": `ReportConfigCard_buttonContainer__L5cix`,
	"generateButton": `ReportConfigCard_generateButton__seUD9`,
	"tableListButtons": `ReportConfigCard_tableListButtons__VATcQ`
};
export default ___CSS_LOADER_EXPORT___;
